/* eslint-disable vue/html-self-closing */
<template>
  <div>
    <!-- FRAMEWORK FILTER -->
    <div class="border-bottom text-center block nav-wrapper">
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'all' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'all'), (typeFilter = 'all')
        "
      >
        All
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'vue' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'vue'), (typeFilter = 'all')
        "
      >
        Vue
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'react' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'react'), (typeFilter = 'all')
        "
      >
        React
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'jekyll' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'jekyll'), (typeFilter = 'all')
        "
      >
        Jekyll
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'gatsby' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'gatsby'), (typeFilter = 'all')
        "
      >
        Gatsby
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'html' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'html'), (typeFilter = 'all')
        "
      >
        HTML
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'css' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'css'), (typeFilter = 'all')
        "
      >
        CSS
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'vscode' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'vscode'), (typeFilter = 'all')
        "
      >
        VSCODE
      </button>
      <button
        class="btn-nav btn-small"
        :class="{ 'btn-nav-active': frameworkFilter === 'nocode' }"
        @click="
          refreshAd()
          ;(frameworkFilter = 'nocode'), (typeFilter = 'all')
        "
      >
        NoCode
      </button>
    </div>
    <!-- second filter area-->
    <div class="filterBox grid">
      <!-- FILTER TYPE BUTTONS -->
      <div class="text-center p-1 inline">
        <button
          class="btn-nav btn"
          :class="{ 'btn-nav-active': typeFilter === 'all' }"
          @click="
            refreshAd()
            typeFilter = 'all'
          "
        >
          All
        </button>
        <button
          v-if="
            frameworkFilter !== 'vscode' &&
              frameworkFilter !== 'css' &&
              frameworkFilter !== 'html' &&
              frameworkFilter !== 'nocode'
          "
          class="btn-nav btn"
          :class="{ 'btn-nav-active': typeFilter === 'component' }"
          @click="
            refreshAd()
            typeFilter = 'component'
          "
        >
          Components
        </button>
        <button
          v-if="
            frameworkFilter !== 'vscode' &&
              frameworkFilter !== 'jekyll' &&
              frameworkFilter !== 'css' &&
              frameworkFilter !== 'gatsby' &&
              frameworkFilter !== 'nocode' &&
              frameworkFilter !== 'nocode'
          "
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'ui kit' }"
          @click="
            refreshAd()
            typeFilter = 'ui kit'
          "
        >
          UI Kits
        </button>
        <button
          v-if="frameworkFilter === 'all' || frameworkFilter === 'css'"
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'framework' }"
          @click="
            refreshAd()
            typeFilter = 'framework'
          "
        >
          CSS Frameworks
        </button>
        <button
          v-if="
            frameworkFilter === 'all' ||
              frameworkFilter === 'vscode' ||
              frameworkFilter === 'jekyll' ||
              frameworkFilter === 'gatsby'
          "
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'theme' }"
          @click="
            refreshAd()
            typeFilter = 'theme'
          "
        >
          Themes
        </button>
        <button
          v-if="frameworkFilter === 'all' || frameworkFilter === 'vscode'"
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'extension' }"
          @click="
            refreshAd()
            typeFilter = 'extension'
          "
        >
          Extensions
        </button>
        <button
          v-if="
            frameworkFilter !== 'vscode' &&
              frameworkFilter !== 'css' &&
              frameworkFilter !== 'jekyll' &&
              frameworkFilter !== 'html' &&
              frameworkFilter !== 'gatsby' &&
              frameworkFilter !== 'nocode'
          "
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'app' }"
          @click="
            refreshAd()
            typeFilter = 'app'
          "
        >
          Full Apps
        </button>
        <button
          v-if="frameworkFilter !== 'vscode' && frameworkFilter !== 'nocode'"
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'learning' }"
          @click="
            refreshAd()
            typeFilter = 'learning'
          "
        >
          Learning
        </button>
        <button
          v-if="frameworkFilter === 'react'"
          class="btn-nav"
          :class="{ 'btn-nav-active': typeFilter === 'boilerplate' }"
          @click="
            refreshAd()
            typeFilter = 'boilerplate'
          "
        >
          Boilerplate
        </button>
        <input
          v-model="searchFilter"
          class="searchBox inline ml-2"
          type="text"
          aria-label="search box"
          placeholder="Search for a keyword..."
        />
        <button
          v-if="searchFilter !== ''"
          class="btn-danger clear-filter"
          @click="clearFilter"
        >
          Clear
        </button>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div
        v-if="filtered.length == 0"
        class="mt-4 text-grey text-center medium"
      >
        <img src="../assets/images/site/nothingfound.gif" alt="nothing here" />
      </div>
    </transition>
    <!-- CARBON ADS -->
    <div v-if="!filtered.length == 0" :key="adKey" class="carbonads-wrapper">
      <CarbonAds />
    </div>
    <!-- CARDS -->
    <transition-group class="card-wrapper" name="list-complete">
      <div v-for="(card, index) in filtered" :key="index" class="card">
        <div class="card-overlay">
          <div class="button-box">
            <a v-if="card.previewUrl" :href="card.previewUrl" target="blank">
              <button class="btn btn-large card-btn">PREVIEW</button>
            </a>

            <a v-if="card.viewUrl" :href="card.viewUrl" target="blank">
              <button class="btn btn-large card-btn">VIEW</button>
            </a>
            <a v-if="card.demoUrl" :href="card.demoUrl" target="blank">
              <button class="btn btn-large card-btn">DEMO</button>
            </a>
            <a v-if="card.listenUrl" :href="card.listenUrl" target="blank">
              <button class="btn btn-large card-btn">LISTEN</button>
            </a>
          </div>
        </div>
        <div class="card-body">
          <img
            class="card-img"
            :src="require(`../assets/images/${card.img}`)"
            alt="resource img"
          />
          <!-- FRAMEWORK LOGOS -->
          <img
            v-if="card.framework === 'vue'"
            class="framework-logo"
            src="../assets/images/site/vue_logo.svg"
            alt="vue"
          />
          <img
            v-if="card.framework === 'react'"
            class="framework-logo"
            src="../assets/images/site/react_logo.svg"
            alt="react"
          />
          <img
            v-if="card.framework === 'jekyll'"
            class="framework-logo"
            src="../assets/images/site/jekyll_logo.svg"
            alt="jekyll"
          />
          <img
            v-if="card.framework === 'gatsby'"
            class="framework-logo"
            src="../assets/images/site/gatsby_logo.svg"
            alt="gatsby"
          />
          <img
            v-if="card.framework === 'html'"
            class="shield-logo"
            src="../assets/images/site/html_logo.svg"
            alt="html"
          />
          <img
            v-if="card.framework === 'css'"
            class="shield-logo"
            src="../assets/images/site/css_logo.svg"
            alt="css"
          />
          <img
            v-if="card.framework === 'vscode'"
            class="framework-logo"
            src="../assets/images/site/vscode_logo.svg"
            alt="vscode"
          />
          <img
            v-if="card.framework === 'nocode'"
            class="framework-logo"
            src="../assets/images/site/nocode_logo.svg"
            alt="vscode"
          />
          <h4 class="card-title bold">
            {{ card.title }}
          </h4>
          <h6 class="card-subtitle">
            {{ card.subtitle }}
          </h6>
        </div>
      </div>
    </transition-group>

    <div class="button-spacer border-bottom border-top">
      <span class="center-btn">
        <router-link to="/submit">
          <button class="submit btn btn-primary btn-medium">
            Submit Resource
          </button>
        </router-link>
      </span>
    </div>
    <!-- FOOTER ARTICLE CARDS -->
    <h2 class="mt-5">
      Articles of Interest
    </h2>

    <transition-group class="article-wrapper" name="list-complete">
      <div v-for="(article, index) in articles" :key="index" class="card">
        <div class="card-overlay overlay-article">
          <div class="button-box">
            <a
              v-if="article.viewUrl !== '' && article.viewUrl !== undefined"
              :href="article.viewUrl"
              target="blank"
            >
              <button class="btn btn-large card-btn">VIEW</button>
            </a>
          </div>
        </div>
        <div class="card-body">
          <img
            class="article-img"
            :src="require(`../assets/images/${article.img}`)"
            alt="resource img"
          />
          <!-- TYPE LOGO -->
          <h4 class="card-title bold">
            {{ article.title }}
          </h4>
          <h6 class="card-subtitle">
            {{ article.subtitle }}
          </h6>
          <div class="article-footer">
            <img
              class="avatar"
              :src="require(`../assets/images/${article.avatar}`)"
              alt="author"
            />
            <div class="creator">
              {{ article.creator }}
            </div>
            <img
              v-if="article.type === 'medium'"
              class="framework-logo article-logo"
              src="../assets/images/site/medium.svg"
              alt="medium"
            />
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import vueData from '@/data/vue.json'
import reactData from '@/data/react.json'
import jekyllData from '@/data/jekyll.json'
import gatsbyData from '@/data/gatsby.json'
import htmlData from '@/data/html.json'
import cssData from '@/data/css.json'
import vscodeData from '@/data/vscode.json'
import nocodeData from '@/data/nocode.json'
import bottomArticles from '@/data/articles.json'
import CarbonAds from '@/components/common/CarbonAds'

export default {
  name: 'Home',
  components: { CarbonAds },

  data() {
    return {
      adKey: '',
      frameworkFilter: 'all',
      count: 0,
      typeFilter: 'all',
      keywords: '',
      searchFilter: '',
      cards: [
        ...vueData.cards,
        ...reactData.cards,
        ...jekyllData.cards,
        ...gatsbyData.cards,
        ...htmlData.cards,
        ...cssData.cards,
        ...vscodeData.cards,
        ...nocodeData.cards
      ],
      articles: bottomArticles.articles,
      isModalVisible: false
    }
  },

  computed: {
    filtered() {
      return this.cards.filter(card => {
        return (
          (card.framework === this.frameworkFilter ||
            this.frameworkFilter === 'all') &&
          (card.type === this.typeFilter || this.typeFilter === 'all') &&
          (card.keywords === this.keywords || this.keywords === '') &&
          (card.subtitle
            .toLowerCase()
            .includes(this.searchFilter.toLowerCase()) ||
            card.title.toLowerCase().includes(this.searchFilter.toLowerCase()))
        )
      })
    }
  },
  methods: {
    clearFilter() {
      this.searchFilter = ''
    },
    refreshAd() {
      this.adKey += 1
    }
    //   showModal(card) {
    //     this.isModalVisible = true;
    //     this.title = card.title;
    //     this.img = card.img;
    //     this.previewUrl = card.previewUrl;
    //     this.downloadUrl = card.downloadUrl;
    //     this.isModalVisible = true;
    //   },
    //   closeModal() {
    //     this.isModalVisible = false;
    //   }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.clear-filter {
  margin-left: 10px;
  margin-top: -4px;
}

@media (max-width: 600px) {
  .carbonads-wrapper {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media (max-width: 601px) {
  #cta44181 {
    display: none !important;
  }
}

.center-btn {
  text-align: center;
  display: block;
}

.button-spacer {
  margin-top: 50px;
  padding: 25px;
}

.article-wrapper {
  margin: 0 auto;
  display: grid;
  padding: 30px 28px;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 30px;
  align-items: stretch;
  .card-img {
    max-height: 200px;
  }
}

.article-img {
  object-fit: cover;
  max-height: 100px;
  width: 100%;
  min-height: 200px;
  border-radius: 3px;
  margin-bottom: 10px;
}

@media (max-width: 1180px) {
  .article-img {
    max-height: 200px;
  }
}

.article-logo {
  position: absolute;
  bottom: -30px;
  right: -5px;
}

.article-footer {
  margin-bottom: 40px;
  position: relative;
}

.creator {
  font-size: 12px;
  font-weight: 600;
  color: $grey;
  float: left;
  margin-top: 8px;
  margin-left: 5px;
}

.avatar {
  border: 1px solid $grey-ultralight;
  width: 30px;
  height: 30px;
  box-shadow: none;
  float: left;
}

.card-btn {
  margin-left: 5px;
  margin-right: 5px;
}

.nav-wrapper {
  padding: 10px;
}

.framework-logo {
  border-radius: 0px !important;
  float: right;
  margin-top: 20px;
  margin-right: 10px;
  width: 30px;
}

.shield-logo {
  border-radius: 0px !important;
  float: right;
  margin-top: 10px;
  margin-right: 10px;
  width: 30px;
}

.searchBox {
  max-width: 300px;
  border: 2px solid #e3e3e3;
  padding: 6px;
}

.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
  transform: translateY(30px);
}

.modal-btn {
  margin: 10px;
}

.card-overlay {
  display: hidden;
  transition: $ease;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  border-radius: 4px;

  &:hover {
    background-color: rgba($green, 0.3);
    // filter: hue-rotate(30deg);
    .button-box {
      display: block;
      text-align: center;
      margin-top: 36%;
    }
  }
  .button-box {
    display: none;
  }
}
@media (max-width: 800px) {
  .button-box {
    margin-top: 25% !important;
  }
}

.overlay-article {
  z-index: 400;
  &:hover {
    background-color: rgba($blue, 0.35) !important;
    filter: hue-rotate(30deg);
  }
}
</style>
